import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: '首页' },
  { path: '/category/acting-career', label: '演艺经历' },
  { path: '/category/works', label: '作品集' },
  { path: '/category/gallery', label: '写真图集' },
  { path: '/category/news', label: '最新动态' },
  { path: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 80);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link
            to="/"
            className="flex items-center gap-2 group"
          >
            <span className="font-heading text-xl md:text-2xl font-bold text-foreground-950 tracking-wide">
              孟若羽
            </span>
            <span className="hidden sm:inline text-xs text-foreground-500 font-light tracking-widest uppercase">
              Official Fansite
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive =
                link.path === '/'
                  ? location.pathname === '/'
                  : location.pathname.startsWith(link.path);
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`relative px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap ${
                    isActive
                      ? 'text-primary-600 bg-primary-100'
                      : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="https://weibo.com/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-9 h-9 flex items-center justify-center rounded-full text-foreground-600 hover:text-primary-600 hover:bg-primary-50 transition-colors duration-200"
              aria-label="关注微博"
            >
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a
              href="https://space.bilibili.com/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-9 h-9 flex items-center justify-center rounded-full text-foreground-600 hover:text-primary-600 hover:bg-primary-50 transition-colors duration-200"
              aria-label="关注B站"
            >
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-full text-foreground-700 hover:bg-background-200 transition-colors duration-200"
            aria-label={isMobileMenuOpen ? '关闭菜单' : '打开菜单'}
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </nav>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-6 py-4 flex flex-col gap-1">
            {navLinks.map((link) => {
              const isActive =
                link.path === '/'
                  ? location.pathname === '/'
                  : location.pathname.startsWith(link.path);
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors duration-200 ${
                    isActive
                      ? 'text-primary-600 bg-primary-50'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>
          <div className="px-6 pb-4 flex items-center gap-3">
            <a
              href="https://weibo.com/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center rounded-full text-foreground-600 hover:text-primary-600 hover:bg-primary-50 transition-colors duration-200"
              aria-label="关注微博"
            >
              <i className="ri-weibo-line text-xl"></i>
            </a>
            <a
              href="https://space.bilibili.com/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center rounded-full text-foreground-600 hover:text-primary-600 hover:bg-primary-50 transition-colors duration-200"
              aria-label="关注B站"
            >
              <i className="ri-bilibili-line text-xl"></i>
            </a>
          </div>
        </div>
      )}
    </header>
  );
}